import { useEffect, useRef } from 'react';
import { REACT_APP_NAME } from 'src/utils/constants/constants';
import { ClientLogRequest, LogLevel } from 'src/WebApiController';
import { onCLS, onFCP, onINP, onLCP, onTTFB } from 'web-vitals';

import { useClientLogContext } from '../ClientLogContext';

const trimMetricValue = (metricValue: number) => Number(metricValue.toFixed(2));

const getTabId = () => {
  return sessionStorage.tabId
    ? sessionStorage.tabId
    : (sessionStorage.tabId = Math.random());
};

const buildLogRequest = (
  category: string,
  additionalInfo: { [key: string]: number | string }
): ClientLogRequest => {
  return {
    logLevel: LogLevel.Information,
    applicationSource: REACT_APP_NAME,
    errorId: getTabId(),
    error: 'WebVitals',
    pageUrl: window.location.href,
    componentStack: category,
    timestamp: new Date().toISOString(),
    additionalInfo,
  };
};

export const useReportWebVitals = (enabled: boolean) => {
  const initializedRef = useRef(false);
  // TODO: migrate this to @stubhub/track
  const { logEvent } = useClientLogContext();

  useEffect(() => {
    if (!enabled) {
      return;
    }
    if (!initializedRef.current) {
      initializedRef.current = true;

      // Cumulative Layout Shift (CLS)
      onCLS((metric) => {
        logEvent(
          buildLogRequest('CLS', { value: trimMetricValue(metric.value) })
        );
      });

      // First Contentful Paint (FCP)
      onFCP((metric) => {
        logEvent(
          buildLogRequest('FCP', { value: trimMetricValue(metric.value) })
        );
      });

      // Largest Contentful Paint (LCP)
      onLCP((metric) => {
        logEvent(
          buildLogRequest('LCP', { value: trimMetricValue(metric.value) })
        );
      });

      // Time to First Byte (TTFB)
      onTTFB((metric) => {
        logEvent(
          buildLogRequest('TTFB', { value: trimMetricValue(metric.value) })
        );
      });

      // Interaction to Next Paint (INP)
      onINP((metric) => {
        logEvent(
          buildLogRequest('INP', { value: trimMetricValue(metric.value) })
        );
      });
    }
  }, [enabled, logEvent]);
};
